module.exports = __webpack_public_path__ + "static/media/dark_lambo.01a3a54d.jpg";